/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { User } from "@src/app/model/user";
import { CreditorsListComponent } from "@src/app/modules/txn/creditors-list/creditors-list.component";
import { DateHelper } from "@src/app/shared/dateHelper";
import { NavRoute } from "@src/app/shared/NavRoute";

export const CreditorsListPageNavRoute = new NavRoute('creditorsList', ()=>CreditorsListComponent, 'paid').setViews((u: User) => {
    return [
        {
            id: 'current',
            name: 'Current Creditors List',
            helpText: 'Current outstanding balances owed to each supplier',
        },
        {
            id: 'asAtDate',
            name: 'Creditors as at Date',
            helpText: 'Creditor balances as at end of previous financial period; adjust the date to show balances at a date of your choosing',
            filterFields: {
                asAtDate: u.currentTeam?.currentPeriod?.from ?
                    DateHelper.adjustDate(u.currentTeam?.currentPeriod?.from, -1) : '1999-12-31'
            },
        }
    ]
});
